export const SUGGESTED_PROVIDER_SEARCH_PARAM_KEY = "suggestedProvider" as const;

export const EMAIL_PROVIDER = "email" as const;

export type EmailProvider = typeof EMAIL_PROVIDER;
